export default "__VITE_ASSET__SvGWSbfL__"